import { numbering as numbering_1 } from './numbering.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';

import { toggleNumbering } from 'roosterjs-editor-api';

const numbering: RibbonButton = {
    key: 'numbering',
    title: () => loc(numbering_1),
    imageSrc: require('../svg/numbering.svg'),
    imageRtlSrc: require('../svg/numbering-rtl.svg'),
    shortcut: 'ctrl+/',
    buttonState: formatState =>
        formatState.isNumbering ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleNumbering(plugin.getEditor()),
};

export default numbering;
